import React, { useState } from 'react';
import { Card, Table, Button, Badge, Tabs, Tab } from 'react-bootstrap';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { CME_ADMIN_API } from '../../../../utils/apiUrl';
import { DeleteSingle, Get, Post } from '../../../../utils/httpProvider';
import { messageToast, status200 } from '../../../../utils/define';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import CMEDictionaryAddEditModal from './CMEDictionaryAddEditModal';

const CMEDictionary = () => {
    const [key, setKey] = useState('vaitro');
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const [openModal, setOpenModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    // Fetch VaiTro
    const { isLoading: isLoadingVT, data: dataVT, refetch: refetchVT } = useQuery(
        ['cmeVaiTroData'],
        () => Get(CME_ADMIN_API.GET_CME_VAITRO)
    );

    // Fetch DonViTinh
    const { isLoading: isLoadingDVT, data: dataDVT, refetch: refetchDVT } = useQuery(
        ['cmeDonViTinhData'],
        () => Get(CME_ADMIN_API.GET_CME_DONVITINH)
    );

    const deleteVaiTroFunc = useMutation((id) => DeleteSingle(`${CME_ADMIN_API.DELETE_CME_VAITRO}/${id}`));
    const deleteDonViTinhFunc = useMutation((id) => DeleteSingle(`${CME_ADMIN_API.DELETE_CME_DONVITINH}/${id}`));

    const upsertVaiTroFunc = useMutation((data) => Post(CME_ADMIN_API.UPSERT_CME_VAITRO, null, data));
    const upsertDonViTinhFunc = useMutation((data) => Post(CME_ADMIN_API.UPSERT_CME_DONVITINH, null, data));

    const handleAdd = () => {
        setSelectedData(null);
        setOpenModal(true);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setOpenModal(true);
    };

    const saveConfig = (values) => {
        if (key === 'vaitro') {
            const payload = { 
                ...selectedData, 
                tenVaiTro: values.tenVaiTro,
                thuTu: values.thuTu
            };
            upsertVaiTroFunc.mutate(payload, {
                onSuccess: (res) => {
                    if (res.status === status200 || res === true || res.id) {
                        toast.success(messageToast.messageToastUpdateSuccess);
                        refetchVT();
                        setOpenModal(false);
                    }
                }
            });
        } else {
            const payload = { 
                ...selectedData, 
                tenDonViTinh: values.tenDonViTinh,
                thuTu: values.thuTu
            };
            upsertDonViTinhFunc.mutate(payload, {
                onSuccess: (res) => {
                    if (res.status === status200 || res === true || res.id) {
                        toast.success(messageToast.messageToastUpdateSuccess);
                        refetchDVT();
                        setOpenModal(false);
                    }
                }
            });
        }
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        const func = key === 'vaitro' ? deleteVaiTroFunc : deleteDonViTinhFunc;

        func.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201 || res === true) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    if (key === 'vaitro') refetchVT();
                    else refetchDVT();
                } else {
                    toast.error(res?.message || messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const listVT = dataVT?.$values ? dataVT.$values : dataVT || [];
    const listDVT = dataDVT?.$values ? dataDVT.$values : dataDVT || [];

    const renderTable = (list, isLoading, isVaiTro) => {
        return (
            <Table bordered hover>
                <thead className="thead-light">
                    <tr>
                        <th className="text-center" style={{ width: '50px' }}>STT</th>
                        <th>Tên {isVaiTro ? 'Vai trò' : 'Đơn vị tính'}</th>
                        <th className="text-center" style={{ width: '150px' }}>Thứ tự hiển thị</th>
                        <th className="text-center" style={{ width: '150px' }}>Hành động</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr><td colSpan={4} className="text-center">Đang tải...</td></tr>
                    ) : list.length === 0 ? (
                        <tr><td colSpan={4} className="text-center">Chưa có dữ liệu</td></tr>
                    ) : (
                        list.map((item, idx) => (
                            <tr key={item.id}>
                                <td className="text-center">{idx + 1}</td>
                                <td>{isVaiTro ? item.tenVaiTro : item.tenDonViTinh}</td>
                                <td className="text-center"><Badge variant="info">{item.thuTu || '-'}</Badge></td>
                                <td className="text-center">
                                    <Button variant="link" size="sm" className="text-primary p-0 mr-3" onClick={() => handleEdit(item)}>
                                        Sửa
                                    </Button>
                                    <Button variant="link" size="sm" className="text-danger p-0" onClick={() => deleteAction(item.id, isVaiTro ? item.tenVaiTro : item.tenDonViTinh)}>
                                        Xóa
                                    </Button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        );
    };

    return (
        <div className="container-fluid">
            <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0"><i className="fas fa-book mr-2"></i>Quản lý Danh mục CME (Từ điển)</h5>
                    <Button variant="light" size="sm" onClick={handleAdd} className="ml-auto">
                        <i className="fas fa-plus mr-1"></i>Thêm {key === 'vaitro' ? 'Vai trò' : 'Đơn vị tính'}
                    </Button>
                </Card.Header>
                <Card.Body>
                    <Tabs
                        id="cme-dictionary-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                    >
                        <Tab eventKey="vaitro" title={<span><i className="fas fa-user-tag mr-2"></i>Vai trò</span>}>
                            <div className="table-responsive">
                                {renderTable(listVT, isLoadingVT, true)}
                            </div>
                        </Tab>
                        <Tab eventKey="donvitinh" title={<span><i className="fas fa-balance-scale mr-2"></i>Đơn vị tính</span>}>
                            <div className="table-responsive">
                                {renderTable(listDVT, isLoadingDVT, false)}
                            </div>
                        </Tab>
                    </Tabs>
                </Card.Body>
            </Card>

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={acceptDelete}
                handleCancel={() => setOpenConfirmDeleteModal(false)}
                content={`Bạn có chắc chắn muốn xóa ${key === 'vaitro' ? 'vai trò' : 'đơn vị tính'}: "${confirmDelMessage}"?`}
            />

            <CMEDictionaryAddEditModal
                isOpen={openModal}
                type={key}
                handleClose={() => setOpenModal(false)}
                handleSave={saveConfig}
                data={selectedData}
            />
        </div>
    );
};

export default CMEDictionary;
